import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    withdrawalAmountHeader: {
        id: '_.rbl_dashboard.approved_offer.withdrawal_amount_header',
        defaultMessage: 'I want to withdraw {input}'
    },
    withdrawalAmountError: {
        id: '_.rbl_dashboard.approved_offer.withdrawal_amount_error',
        defaultMessage: 'Enter an amount between {minAmount} and {maxAmount}'
    },
    drawdownSweepHeader: {
        id: '_.rbl_dashboard.approved_offer.drawdown_sweep_header',
        defaultMessage: "I'll repay with {input} of my monthly revenue"
    },
    drawdownSweepError: {
        id: '_.rbl_dashboard.approved_offer.drawdown_sweep_error',
        defaultMessage:
            'Enter an repayment percentage between {minSweep}% and {maxSweep}%'
    },
    minimumRepaymentsNotice: {
        id: '_.rbl_dashboard.approved_offer.minimum_repayments_notice',
        defaultMessage: `We'll automatically take this percentage of your revenue as repayment every month. If revenues dip and these monthly repayments aren't adding up to {minimumAmount} every {minimumRepaymentInterval}, you'll need to pay the difference.`
    },
    withdrawalAmountConfirmation: {
        id: '_.rbl_dashboard.approved_offer.withdrawal_amount_confirmation',
        defaultMessage: "You're withdrawing:"
    },
    loanSummaryTitle: {
        id: '_.rbl_dashboard.approved_offer.loan_summary_title',
        defaultMessage: 'Withdrawal summary'
    },
    feeAmount: {
        id: '_.rbl_dashboard.approved_offer.fee_amount',
        defaultMessage: 'Your fixed fee is:'
    },
    feeProportion: {
        id: '_.rbl_dashboard.approved_offer.fee_proportion',
        defaultMessage: ' of your withdrawal'
    },
    noInterest: {
        id: '_.rbl_dashboard.approved_offer.no_interest',
        defaultMessage: '(No interest at all)'
    },
    totalRepayment: {
        id: '_.rbl_dashboard.approved_offer.total_repayment',
        defaultMessage: 'Your total repayment is:'
    },
    cta: {
        id: '_.rbl_dashboard.approved_offer.drawdown_cta',
        defaultMessage: 'Continue with {amount}'
    },
    repaymentInterval: {
        id: '_.rbl_dashboard.approved_offer.repayment_interval',
        defaultMessage: '{interval} months'
    },
    leftToPayLabel: {
        id: '_.rbl_dashboard.approved_offer.left_to_pay_label',
        defaultMessage: 'Left To Pay:'
    },
    howIsTheFeeCalculated: {
        id: '_.rbl_dashboard.approved_offer.how_is_the_fee_calculated',
        defaultMessage: 'How is the fee calculated?'
    },
    feeExplanation: {
        id: '_.rbl_dashboard.approved_offer.fee_explanation',
        defaultMessage:
            'For topups we calculate a fixed fee taking into account the total outstanding principal after funding and the new loan duration. We then discount this by the fee already paid for the unused period of the existing loan.'
    },
    outstandingPrincipal: {
        id: '_.rbl_dashboard.approved_offer.outstanding_principal',
        defaultMessage: 'Outstanding principal:'
    },
    aditionalPayout: {
        id: '_.rbl_dashboard.approved_offer.aditional_payout',
        defaultMessage: 'Additional payout:'
    },
    principleAfterFunding: {
        id: '_.rbl_dashboard.approved_offer.principle_after_funding',
        defaultMessage: 'Principle after funding:'
    },
    fixedFeeForNewLoan: {
        id: '_.rbl_dashboard.approved_offer.fixed_fee_for_new_loan',
        defaultMessage: 'Fixed fee for new loan:'
    },
    refund: {
        id: '_.rbl_dashboard.approved_offer.refund',
        defaultMessage: 'Refund from unused period of existing loan:'
    },
    payableFee: {
        id: '_.rbl_dashboard.approved_offer.payable_fee',
        defaultMessage: 'Fixed fee still payable:'
    },
    discountedOffer: {
        id: '_.rbl_dashboard.discountedOffer',
        defaultMessage: 'Our offer for you: You save {amount}'
    }
});
